import { TableHead } from "../../../../common/dataClass/Default"
import { Listing } from "../listing/class"

class SaleCommission{
  constructor(id, name, value, product = []) {
    this.id = id
    this.name = name
    this.value = value
    this.product = product
    this.isDisable = true
  }
}

class SaleProductTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class SaleProductTableBody extends Listing{
  constructor(){
    super()
    this.check = false
  }
}

class SaleNewModule{
  static NEWSALEPRODUCTTABLEHEAD(){
    let arr = [
      new SaleProductTableHead('选择', 'check', '50'),
      new SaleProductTableHead('商品图片', 'img', '100'),
      new SaleProductTableHead('商品型号', 'model', '100'),
      new SaleProductTableHead('商品名称', 'name', '100'),
      new SaleProductTableHead('国家站点', 'getCountryName', '100'),
      new SaleProductTableHead('卖家SKU', 'sku', '100'),
      new SaleProductTableHead('FNSKU', 'fnSku', '100'),
      new SaleProductTableHead('ASIN', 'asin', '100'),
    ]
    return arr
  }
}

export { SaleCommission, SaleNewModule, SaleProductTableBody }
